// Definition ID: def:rosta:content:proverb
// Curated African proverbs rendered in the BluePages footer to honour the
// continent's oral wisdom. Source: res/Proverbs/SoutherAfricanProverbs.md
// (schema "african-proverbs.v1"). Imported (not fetched) so the footer works
// offline and ships in the static bundle.

export interface ProverbOrigin {
  culture: string;
  language: string;
  region: string;
}

export interface ProverbConfidence {
  level: 'high' | 'medium' | 'low';
  reason: string;
}

export interface Proverb {
  id: number;
  proverb: string;
  meaning: string;
  themes: string[];
  origin: ProverbOrigin;
  confidence: ProverbConfidence;
}

import raw from '../data/proverbs.json';

const data = raw as { proverbs: Proverb[] };

/** All curated proverbs, in source order. */
export const PROVERBS: Proverb[] = data.proverbs;

/** Random proverb (used for a stable first impression on each mount). */
export function randomProverb(): Proverb {
  return PROVERBS[Math.floor(Math.random() * PROVERBS.length)];
}
